import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {postGeoAhn3D} from "@/http/services/http-services-geo";
import toastr from "toastr";
import {getBySelector} from "@/helpers/element-helper";

export function measureAhn(element, olGeometry, wktString, area, step, isLine = false) {
    const data = {}
    data.bbox0 = olGeometry.getExtent()
    data.geometrie0 = wktString
    data.stap = 1 / parseFloat(step)
    data.basisopp = area

    if(isLine) {
        data.isLine = true
    }

    blockUi('#divCardMeasureAhn', 0.1)

    postGeoAhn3D(data).then(result => {
        const iframe3dLocation = document.getElementById('iframe3dLocation')
        if(iframe3dLocation) {
            iframe3dLocation.parentElement.remove()
        }
        unblockUi('#divCardMeasureAhn')

        if(result.includes('Gebied is te groot')) {
            toastr.warning('Het gebied is te groot. Probeer een groter getal')
            return
        }

        const div = document.createElement("div");
        div.classList.add('embed-responsive')
        div.classList.add('embed-responsive-4by3')
        div.classList.add('h-100')
        div.innerHTML = '<iframe class="embed-responsive-item" id="iframe3dLocation" src="' + result + '">'
        element.insertAdjacentElement('beforeend', div)

        const linkElement = getBySelector('#aMeasureResult')

        linkElement.classList.remove('d-none')
        linkElement.href = result

    }, () => {
        //// console.log('error')
        toastr.error('Er is iets fout gegaan. Neem contact op met de beheerder')
        unblockUi('#divCardMeasureAhn')
    })
}
